import { render, staticRenderFns } from "./PollForm.vue?vue&type=template&id=6b1d4924&scoped=true&"
import script from "./PollForm.vue?vue&type=script&lang=js&"
export * from "./PollForm.vue?vue&type=script&lang=js&"
import style0 from "./PollForm.vue?vue&type=style&index=0&id=6b1d4924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d4924",
  null
  
)

export default component.exports